// src/components/dashboard/MergeConfirmationModal.js
// Updated: 10/20/2025 04:15 PM

import React, { useState } from 'react';
import ModalWrapper from '../common/ModalWrapper';
import Spinner from '../common/Spinner';
import { FaUser, FaEnvelope, FaExclamationTriangle } from 'react-icons/fa';

const MergeConfirmationModal = ({ manualUser, authUser, onConfirm, onCancel, zIndexClass }) => {
  const [loading, setLoading] = useState(false);

  const handleConfirm = async () => {
    setLoading(true);
    try {
      await onConfirm();
      // No need to call onClose here, onConfirm should handle it via parent state
    } catch (e) {
      // Error handled by caller's toast usually
    } finally {
      setLoading(false); // Stop loading indicator here
    }
  };

  if (!manualUser || !authUser) return null; // Should not happen if called correctly

  return (
    <ModalWrapper onClose={onCancel} size="lg" zIndexClass={zIndexClass}>
      <div className="p-6 border-b">
        <h3 className="text-xl font-semibold text-neutral-gray">Confirm User Merge</h3>
      </div>
      <div className="p-6 space-y-4">
        <p className="text-sm text-gray-600">
          You are about to merge the following two user records. Relationship links (parents, spouse) from the
          <span className="font-semibold"> manual record</span> will be transferred to the
          <span className="font-semibold"> authenticated record</span>. Child links pointing to the manual record will also be updated.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {/* Manual User Card */}
          <div className="border rounded-md p-3 bg-red-50">
            <h4 className="font-semibold text-red-800 flex items-center gap-2"><FaUser /> Manual Record (Will be Deleted)</h4>
            <p className="mt-1 text-sm text-red-700">{manualUser.firstName} {manualUser.lastName}</p>
            <p className="text-xs text-red-600">ID: {manualUser.id.substring(0, 8)}...</p>
            <p className="text-xs text-red-600">Email: None</p>
          </div>
          {/* Authenticated User Card */}
          <div className="border rounded-md p-3 bg-green-50">
             <h4 className="font-semibold text-green-800 flex items-center gap-2"><FaEnvelope /> Authenticated Record (Will be Kept)</h4>
             <p className="mt-1 text-sm text-green-700">{authUser.firstName} {authUser.lastName}</p>
             <p className="text-xs text-green-600">ID: {authUser.id.substring(0, 8)}...</p>
             <p className="text-xs text-green-600 truncate">Email: {authUser.email}</p>
          </div>
        </div>
         <div className="mt-4 p-3 bg-yellow-50 border border-yellow-300 rounded-md text-yellow-800 text-sm flex items-start gap-2">
            <FaExclamationTriangle className="mt-0.5 flex-shrink-0"/>
            <span>
                This action is irreversible. The manual record will be permanently deleted. Ensure these are the correct profiles before proceeding.
            </span>
         </div>
      </div>
      <div className="p-6 bg-gray-50 rounded-b-lg flex justify-end items-center gap-4">
        <button
          type="button"
          onClick={onCancel}
          disabled={loading}
          className="px-4 py-2 bg-white border border-gray-300 rounded-md text-sm font-medium hover:bg-gray-50 disabled:opacity-50"
        >
          Cancel
        </button>
        <button
          type="button"
          onClick={handleConfirm}
          disabled={loading}
          className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 text-sm font-medium disabled:opacity-50 flex items-center gap-2"
        >
          {loading ? <Spinner size="sm" /> : <><FaUser /> Merge Records</>}
        </button>
      </div>
    </ModalWrapper>
  );
};

export default MergeConfirmationModal;